import * as axiosBase from 'axios';

let meta = document.querySelector('meta[name=csrf-token]');
let csrfToken = meta && meta.content;

export default axiosBase.create({
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
    'X-CSRF-Token': csrfToken
  },
  responseType: 'json'
});
